import React, { useEffect, useState } from "react";
import courseStyle from "./courses.module.css";
import {
  BackIcon,
  ForwardIcon,
} from "../../svg";
import { Box, CircularProgress, Slider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCourses,
  getCatSubCategories,
  getCourseLevel,
  getDuration,
  getPayment,
  getRating,
  setFilterValues,
  resetAndSetFilterValues,
  getSearchSuggession,
  getAllActiveWebinars
} from "../redux/courseSlice";
import ErrorPage from "../../component/ErrorPage";
import { useFormState } from "react-dom";


const Webinars = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getFiltersData = useSelector((state) => state.courses);
  const { isLoading, filterValues } = useSelector((state) => state.courses);
  const getAllCoursesData = getFiltersData?.allCourseData?.courses;
  const pagination = getFiltersData?.allCourseData;


  const [webinars, setWebinars] = useState([])

  //Effects
  useEffect(() => {
    dispatch(getCatSubCategories());
    dispatch(getRating());
    dispatch(getDuration());
    dispatch(getPayment());
    dispatch(getCourseLevel());
  }, [dispatch]);


  useEffect(() => {

    const getWebinars = async () => {
      try {
        const data = await dispatch(getAllActiveWebinars()).unwrap();

        if (data) {
          setWebinars(data)
        }

      }
      catch (err) {
        console.log("fetching failed")
      }
    }
    getWebinars()

  }, [
    dispatch, filterValues
  ]);


  const capitalizeFirstLetters = (str) => {
    if (!str) return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };


  console.log(webinars, "webbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")

  
  return (
    <div className={courseStyle.paddingmain}>
      <div className={courseStyle.mobileComponentStyle}>
      </div>
      <div className={courseStyle.app}>

        <main className={courseStyle.mainContent}>
          {isLoading ? (
            <div
              style={{
                display: "grid",
                placeItems: "center",
                height: "50vh",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              {webinars?.length > 0 ? (
                <>
                  <div className={`${courseStyle.cardStyle} ${courseStyle.webinar}`}>
                    {webinars?.map((item, index) => (
                      <div
                        className={courseStyle.MainCardStyle}
                        onClick={() =>
                          navigate(
                            `/webinar/webinar/webinardetails/${item?._id}`
                          )
                        }
                        key={index}
                      >
                        <img
                          src={item?.webinarBanner?.[0]}
                          className={courseStyle.imageView}
                          alt={item?.name}
                          style={{ objectFit: "cover" }}
                        />
                        <div className={courseStyle.scoreStyle}>
                          <div className={courseStyle.totalPriceText}>
                            {/* ₹ {item?.price} */} FREE
                          </div>
                        </div>
                        <div className={courseStyle.descStyle}>
                          {item?.title && item.title?.length > 40
                            ? capitalizeFirstLetters(
                              `${item?.title?.substring(0, 40)}...`
                            )
                            : capitalizeFirstLetters(item?.title)}
                        </div>
                      </div>
                    ))}
                  </div>
                 
                </>
              ) : (
                <ErrorPage />
              )}
            </>
          )}
        </main>
      </div>
      <div className={courseStyle.mobileViewCardContainer}>

        <div>
          {isLoading ? (
            <div
              style={{
                display: "grid",
                placeItems: "center",
                height: "50vh",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              {webinars?.length > 0 ? (
                <>
                  {webinars?.map((item, index) => (
                    <div
                      className={courseStyle.mobileMainCardStyle}
                      onClick={() =>
                        navigate(
                          `/webinar/webinar/webinardetails/${item?._id}`
                        )
                      }
                      key={index}
                    >
                      <img
                        src={item?.webinarBanner?.[0]}
                        className={courseStyle.imageView}
                        alt="Thumbnail"
                      />
                      <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                        <div className={courseStyle.categoryStyle}>
                          <div className={courseStyle.businessStyle}>
                            {/* {Array.isArray(item?.category) &&
                                item?.category?.map((item) => ( */}
                            <>
                              {/* {item.name} */}
                              {item?.category?.name && item?.category?.name?.length > 20
                                ? `${item?.category?.name?.substring(0, 20)}...`
                                : item?.category?.name}
                            </>
                            {/* ))} */}
                          </div>
                          <div className={courseStyle.totalPriceText}>
                            {/* ₹ {item?.price} */} FREE
                          </div>
                        </div>
                        <div className={courseStyle.titleStyle}>
                          {item?.title && item?.title?.length > 40
                            ? `${item?.title?.substring(0, 40)}...`
                            : item?.title}
                        </div>
                      </div>
                    </div>
                  ))}
              
                </>
              ) : (
                <ErrorPage />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Webinars;
